/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Notice from '../../../../components/notice';

const GunTradersPreferences = () => {
    return (
        <Notice status='is-info' showDismiss={false} text='Preference configuration not available for this connection type.' />
    );
};

export default connect((state, ownProps) => ({}), {})(GunTradersPreferences);
